import { render, staticRenderFns } from "./ProjectEditor.vue?vue&type=template&id=6b5d69ec&scoped=true&"
import script from "./ProjectEditor.vue?vue&type=script&lang=js&"
export * from "./ProjectEditor.vue?vue&type=script&lang=js&"
import style0 from "./ProjectEditor.vue?vue&type=style&index=0&id=6b5d69ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5d69ec",
  null
  
)

export default component.exports